import styled from 'styled-components';
import { Popup, Text } from '@cashfree-intl/coherent';

export const StyledLogoDiv = styled.div`
  max-width: 25rem;
  height: 1.875rem;
  align-self: center;
  margin-left: 2rem;
  @media (max-width: 767px) {
    width: 60px;
  }

  .image-wrapper {
    max-height: 1.875rem;
    display: flex;
    justify-centent: center;
    align-items: center;
    @media (max-width: 767px) {
      width: 0;
      display: none;
    }

    .lk-logo {
      max-width: 102px;
    }
  }

  .merchant-img {
    width: 6.375rem;
    height: 1.875rem;
    display: inline-block;
    @media (max-width: 767px) {
      width: 0;
      display: none;
    }
    img.ui.small.image {
      max-width: 102px !important;
      height: 1.875rem;
      display: inline;
      @media (max-width: 767px) {
        display: none;
      }
    }
    img.icici-logo {
      width: 12.5rem;
      height: auto;
      @media (max-width: 767px) {
        display: none;
      }
    }
  }
  img.axis-logo {
    width: 175px;
    height: auto;
    @media (max-width: 767px) {
      display: none;
    }
  }
  .visible_xs {
    width: 0px;
    @media (max-width: 767px) {
      width: 26px;
    }
  }

  .divider {
    margin: 0px 1rem;
    border-left: 1px solid #d8d7dc;
    height: 1.875rem;
    align-items: center;
    opacity: 1;
  }
`;

export const StyledPopup = styled(Popup)`
  &.ui.bottom.popup {
    position: absolute;
    padding: 0.375rem 0.625rem;
    border-radius: 0.125rem;
    margin-top: 0.3125rem;
    border: none;
  }
`;

export const StyledTooltipHeader = styled(Text)`
  font-size: 0.75rem;
  font-family: ${props => props.theme.FONTS.semi_bold};
`;

export const StyledCoachMark = styled.div`
  padding: 10px;
  border-radius: 0.5rem;
  background: linear-gradient(90deg, #240253 5.58%, #2b037b 91.7%);
  .description {
    font-size: 0.75rem;
  }
  .cross-icon {
    height: 0.625rem;
    width: 0.625rem;
  }
`;
